import Launch from '@mui/icons-material/Launch';
import Warning from '@mui/icons-material/Warning';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TaskExtended } from '../../../types';

interface OldVersionWarningBannerProps {
  newestTask: TaskExtended;
  currentTaskTagName: string;
}

/**
 * Warning banner displayed when viewing an older version of a task.
 * Shows a message and provides a button to navigate to the newest version.
 */
export const OldVersionWarningBanner: React.FC<OldVersionWarningBannerProps> = ({
  newestTask,
  currentTaskTagName,
}) => {
  const navigate = useNavigate();

  const navigateToNewestTask = () => {
    const params = new URLSearchParams();
    params.set('store_name', newestTask.storeName);
    params.set('chain_id', newestTask.chainId.toString());
    params.set('store_id', newestTask.storeId.toString());
    params.set('cameraId', newestTask.cameraId.toString());
    params.set('tag_name', newestTask.tagName);
    params.set('image_id', newestTask.imageId.toString());
    params.set('created_at', newestTask.taskCreatedAt);
    params.set('osa_score', newestTask.osaComplianceScore.toString());
    params.set('compliance_score', newestTask.pogComplianceScore.toString());

    navigate(`/tasks/${newestTask.actionTaskId}?${params.toString()}`);
  };

  return (
    <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded-lg flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <Warning className="text-yellow-600" />
        <span className="font-medium">
          You are viewing an older version of {currentTaskTagName}
        </span>
      </div>
      <button
        onClick={navigateToNewestTask}
        className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-colors font-medium flex items-center gap-1"
      >
        View Latest Version
        <Launch fontSize="small" />
      </button>
    </div>
  );
};
